<template>
  <div class="mb-6 flex flex-wrap items-end gap-3 rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
    <div>
      <label class="text-xs uppercase tracking-wide text-gray-500">Prefix</label>
      <input
        v-model="prefix"
        type="text"
        class="mt-1 w-24 rounded-xl border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:border-amber-500"
      />
    </div>
    <div>
      <label class="text-xs uppercase tracking-wide text-gray-500">Next Number</label>
      <input
        v-model.number="nextNumber"
        type="number"
        min="1"
        class="mt-1 w-32 rounded-xl border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:border-amber-500"
      />
    </div>
    <button
      @click="save"
      :disabled="saving"
      class="rounded-xl bg-gray-900 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-gray-800 disabled:opacity-60"
    >
      {{ saving ? 'Saving...' : 'Save Numbering' }}
    </button>
    <span class="text-sm text-gray-400">Next {{ label }}: <span class="font-semibold text-gray-600">{{ prefix }}{{ nextNumber }}</span></span>
    <p v-if="saved" class="w-full text-xs font-medium text-green-600">Numbering updated.</p>
  </div>
</template>

<script>
import { getSettings, setSettings } from '../services/settingsStore'

export default {
  name: 'NumberingSettings',
  props: {
    settingsKey: { type: String, required: true },
    defaultPrefix: { type: String, required: true },
    label: { type: String, default: 'number' }
  },
  data() {
    return {
      prefix: this.defaultPrefix,
      nextNumber: 1001,
      saving: false,
      saved: false
    }
  },
  async mounted() {
    await this.refresh()
  },
  methods: {
    async refresh() {
      const settings = await getSettings(this.settingsKey, { prefix: this.defaultPrefix, nextNumber: 1001 })
      this.prefix = settings.prefix
      this.nextNumber = settings.nextNumber
    },
    async save() {
      this.saving = true
      await setSettings(this.settingsKey, { prefix: this.prefix, nextNumber: this.nextNumber })
      this.saving = false
      this.saved = true
      this.$emit('updated')
      setTimeout(() => { this.saved = false }, 2500)
    }
  }
}
</script>
